module.exports = __webpack_public_path__ + "img/horoz.7fc5b2ad.png";